var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.model && _vm.model.phccloud
    ? _c("div", [
        _c(
          "div",
          {
            staticClass: "page phccloud-page",
            attrs: { id: "print_phccloud" },
          },
          [
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "font-size": "30px",
                  "text-align": "center",
                  "font-weight": "600",
                },
              },
              [
                _c(
                  "table",
                  {
                    staticStyle: {
                      width: "100%",
                      "border-collapse": "collapse",
                      border: "none",
                      "letter-spacing": "5px",
                    },
                  },
                  [
                    _c("tbody", [
                      _c(
                        "tr",
                        {
                          staticStyle: {
                            width: "100%",
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _c(
                            "td",
                            {
                              staticStyle: {
                                "border-collapse": "collapse",
                                border: "none",
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.model.phccloud.reportName
                                    ? _vm.model.phccloud.reportName
                                    : "健康体检报告"
                                )
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]),
                  ]
                ),
                _c("div", [
                  _c("div", [
                    _c("img", {
                      staticStyle: { width: "100%", height: "100%" },
                      attrs: { src: _vm.model.phccloud.barCodeImage },
                    }),
                  ]),
                  _vm.model.phccloud.barCodeImage
                    ? _c(
                        "div",
                        {
                          staticStyle: {
                            "line-height": "0px",
                            "font-size": "15px",
                            "letter-spacing": "0px",
                          },
                        },
                        [_vm._v(_vm._s(_vm.model.phccloud.barCode))]
                      )
                    : _vm._e(),
                ]),
              ]
            ),
            _c(
              "table",
              {
                staticStyle: {
                  "padding-left": "10px",
                  "text-align": "left",
                  width: "100%",
                  "margin-top": "10px",
                  "border-collapse": "collapse",
                  border: "none",
                },
              },
              [
                _c("tbody", [
                  _c(
                    "tr",
                    { staticStyle: { "line-height": "30px", border: "none" } },
                    [
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "65%",
                            "border-collapse": "collapse",
                            border: "none",
                          },
                          attrs: { colspan: "5" },
                        },
                        [
                          _vm._v("学校："),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.phccloud.schoolName
                                  ? _vm.model.phccloud.schoolName
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "td",
                        {
                          attrs: {
                            colspan: "2",
                            tyle: "width: 100px;border-collapse: collapse;border:none;",
                          },
                        },
                        [
                          _vm._v("检查日期："),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.phccloud.checkDate
                                  ? _vm.model.phccloud.checkDate
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "tr",
                    {
                      staticStyle: {
                        "line-height": "30px",
                        width: "100px",
                        border: "none",
                      },
                    },
                    [
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "65%",
                            "border-collapse": "collapse",
                            border: "none",
                          },
                          attrs: { colspan: "5" },
                        },
                        [
                          _vm._v("班级："),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.phccloud.className
                                  ? _vm.model.phccloud.className
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                    ]
                  ),
                ]),
              ]
            ),
            _c(
              "table",
              {
                staticStyle: {
                  "text-align": "center",
                  width: "100%",
                  "border-collapse": "collapse",
                  border: "1px solid black",
                },
              },
              [
                _c("tbody", [
                  _c("tr", { staticStyle: { "line-height": "30px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("姓名")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.phccloud.name
                                ? _vm.model.phccloud.name
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "50px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [_vm._v("性别")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.phccloud.sex
                                ? _vm.model.phccloud.sex
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "30px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("出生日期")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.phccloud.birthday
                                ? _vm.model.phccloud.birthday
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "50px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [_vm._v("民族")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.model.nation ? _vm.model.nation : "")
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "30px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("联系电话")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.phccloud.phone
                                ? _vm.model.phccloud.phone
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "50px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [_vm._v("身份证号")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.phccloud.idcard
                                ? _vm.model.phccloud.idcard
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "30px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("既往病史")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "5" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.phccloud.pastMedicalHistory
                                ? _vm.model.phccloud.pastMedicalHistory
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "30px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("过敏史")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "5" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.phccloud.allergyHistory
                                ? _vm.model.phccloud.allergyHistory
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "30px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "50px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("家族史")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "5" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.phccloud.familyHistory
                                ? _vm.model.phccloud.familyHistory
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "30px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { rowspan: "3" },
                      },
                      [_vm._v("一般情况")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("身高")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.phccloud.height
                                ? _vm.model.phccloud.height
                                : ""
                            )
                          ),
                        ]),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              float: "right",
                              "margin-right": "15px",
                            },
                          },
                          [_vm._v("cm")]
                        ),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "50px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [_vm._v("体重")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.phccloud.weight
                                ? _vm.model.phccloud.weight
                                : ""
                            )
                          ),
                        ]),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              float: "right",
                              "margin-right": "15px",
                            },
                          },
                          [_vm._v("kg")]
                        ),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "30px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("BMI")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.phccloud.bmi
                                ? _vm.model.phccloud.bmi
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "50px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [_vm._v("血压")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.phccloud.systolicPressure
                                ? _vm.model.phccloud.systolicPressure
                                : ""
                            )
                          ),
                        ]),
                        _vm._v("/"),
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.phccloud.diastolicPressure
                                ? _vm.model.phccloud.diastolicPressure
                                : ""
                            )
                          ),
                        ]),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              float: "right",
                              "margin-right": "15px",
                            },
                          },
                          [_vm._v("mmHg")]
                        ),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "30px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("脉搏")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.phccloud.pulse
                                ? _vm.model.phccloud.pulse
                                : ""
                            )
                          ),
                        ]),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              float: "right",
                              "margin-right": "15px",
                            },
                          },
                          [_vm._v("次/分")]
                        ),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "50px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [_vm._v("肺活量")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.phccloud.vitalCapacity
                                ? _vm.model.phccloud.vitalCapacity
                                : ""
                            )
                          ),
                        ]),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              float: "right",
                              "margin-right": "15px",
                            },
                          },
                          [_vm._v("ml")]
                        ),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "30px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { rowspan: "2" },
                      },
                      [_vm._v("裸眼视力")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("左")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.phccloud.nakedLeftEyeVision
                                ? _vm.model.phccloud.nakedLeftEyeVision
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: { width: "45px" },
                        attrs: { rowspan: "2" },
                      },
                      [_vm._v("矫正视力")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "15px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("左")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.phccloud.correctLeftEyeVision
                                ? _vm.model.phccloud.correctLeftEyeVision
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "30px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("右")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.phccloud.nakedRightEyeVision
                                ? _vm.model.phccloud.nakedRightEyeVision
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "15px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("右")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.phccloud.correctRightEyeVision
                                ? _vm.model.phccloud.correctRightEyeVision
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "30px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { rowspan: "4" },
                      },
                      [_vm._v("五官科")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("眼底")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "50px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.phccloud.fundus
                                ? _vm.model.phccloud.fundus
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "50px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [_vm._v("听力")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "50px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.phccloud.hearing
                                ? _vm.model.phccloud.hearing
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "30px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("咽喉")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "50px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.phccloud.pharynx
                                ? _vm.model.phccloud.pharynx
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "50px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [_vm._v("口腔")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "50px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.phccloud.oralCavity
                                ? _vm.model.phccloud.oralCavity
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "30px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("辨色力")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "50px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "4" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.phccloud.distinguishColour
                                ? _vm.model.phccloud.distinguishColour
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "30px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "50px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("其他")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "50px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "4" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.phccloud.facialFeaturesOther
                                ? _vm.model.phccloud.facialFeaturesOther
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "30px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { rowspan: "5" },
                      },
                      [_vm._v("内科")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("营养发育")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "50px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.phccloud.development
                                ? _vm.model.phccloud.development
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "50px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [_vm._v("神经精神")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "50px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.phccloud.neuropsychology
                                ? _vm.model.phccloud.neuropsychology
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "30px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("呼吸系统")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "50px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.phccloud.systemBreathing
                                ? _vm.model.phccloud.systemBreathing
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "50px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [_vm._v("循环系统")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "50px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.phccloud.systemLoop
                                ? _vm.model.phccloud.systemLoop
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "30px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("肝胆")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "50px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.phccloud.liverAndGallbladder
                                ? _vm.model.phccloud.liverAndGallbladder
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "50px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [_vm._v("脾脏")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "50px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.phccloud.spleen
                                ? _vm.model.phccloud.spleen
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "30px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("肾脏")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "50px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "4" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.phccloud.kidney
                                ? _vm.model.phccloud.kidney
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "30px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("其他")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "50px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "4" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.phccloud.insideOther
                                ? _vm.model.phccloud.insideOther
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "30px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { rowspan: "4" },
                      },
                      [_vm._v("外科")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("皮肤")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "50px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.phccloud.skin
                                ? _vm.model.phccloud.skin
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "50px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [_vm._v("淋巴")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "50px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.phccloud.lymph
                                ? _vm.model.phccloud.lymph
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "30px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("甲状腺")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "50px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.phccloud.thyroid
                                ? _vm.model.phccloud.thyroid
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "50px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [_vm._v("脊椎")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "50px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.phccloud.spine
                                ? _vm.model.phccloud.spine
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "30px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("四肢")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "50px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.phccloud.limb
                                ? _vm.model.phccloud.limb
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "50px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [_vm._v("关节")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "50px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.phccloud.joint
                                ? _vm.model.phccloud.joint
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "30px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("其他")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "50px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "4" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.phccloud.surgeryOther
                                ? _vm.model.phccloud.surgeryOther
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "30px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          height: "110px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("检查结论")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "word-wrap": "break-word",
                          overflow: "auto",
                          "flex-wrap": "wrap",
                          "justify-content": "flex-start",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.phccloud.inspectionResults
                                ? _vm.model.phccloud.inspectionResults
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "50px",
                          height: "110px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [_vm._v("医师签名")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [
                        _vm.model.phccloud.doctorSignature
                          ? _c("img", {
                              staticStyle: {
                                height: "40px",
                                width: "100px",
                                "object-fit": "contain",
                              },
                              attrs: {
                                src: _vm.model.phccloud.doctorSignature,
                              },
                            })
                          : _vm._e(),
                      ]
                    ),
                  ]),
                ]),
              ]
            ),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }